import React from 'react';
import { CommonFields, Fields } from '@shared/components/blocks/types';
import { WorkflowAuditComponent } from './WorkflowAuditComponent';
import { WorkflowDateComponent } from './WorkflowDateComponent';
import { WorkflowEmailComponentLowCode } from './WorkflowEmailComponent';
import { WorkflowLookupComponentLowCode } from './WorkflowLookupComponent';
import { WorkflowReferencedInComponent } from './WorkflowReferencedInComponent';
import { WorkflowScheduledAutomationComponentLowCode } from './WorkflowScheduledAutomationComponent';
import { WorkflowStaticTextComponent } from './WorkflowStaticTextComponent';
import { WorkflowTextComponent } from './WorkflowTextComponent';
import { WorkflowTimeTrackerComponent } from './WorkflowTimeTrackerComponent';
import { WorkflowUrlComponentLowCode } from './WorkflowUrlComponent';

export interface WorkflowComponentProps {
  initialData?: any;
  component: MBAPI.WorkflowTemplate_components;
  components?: MBAPI.WorkflowTemplate_components[];
  fields?: CommonFields & Fields;
  onDataChanged?: (componentId: string, data: any | null) => void;
  isReadOnly?: boolean;
  showIcon?: boolean;
  showLabel?: boolean;
  paddingHorizontal?: number;
  iconPad?: number;
  overrides?: MBAPI.ViewTemplate_componentsViewOptions_overrides;
}

export function WorkflowComponent(props: WorkflowComponentProps) {
  const { component } = props;

  switch (component?.type) {
    case 'AUDIT_TAG':
      return <WorkflowAuditComponent {...props} />;
    case 'AUDIT_CHECKBOX':
      return <WorkflowAuditComponent {...props} />;
    case 'AUDIT_TEXT':
      return <WorkflowAuditComponent {...props} />;
    case 'DATE':
      return <WorkflowDateComponent {...props} />;
    case 'EMAIL':
      return <WorkflowEmailComponentLowCode {...props} />;
    case 'TEXT':
      return <WorkflowTextComponent {...props} />;
    case 'SCHEDULED_AUTOMATION':
      return <WorkflowScheduledAutomationComponentLowCode {...props} />;
    case 'STATIC_TEXT':
      return <WorkflowStaticTextComponent {...props} />;
    case 'RELATED_CARD_LOOKUP':
      return <WorkflowLookupComponentLowCode {...props} />;
    case 'TIME_TRACKER':
      return <WorkflowTimeTrackerComponent {...props} />;
    case 'REFERENCED_IN':
      return <WorkflowReferencedInComponent {...props} />;
    case 'URL':
      return <WorkflowUrlComponentLowCode {...props} />;
    default:
      return null;
  }
}
